module.exports = __webpack_public_path__ + "img/level_5.d940c0fd.png";